import React, { useState } from 'react'

import { Checkbox } from '@components/Checkbox'
import { Separator } from '@components/Separator'
import { SheetModalHandle } from '@components/SheetModalHandle'

import {
  Container,
  OptionLabel,
  PressAbleContainer,
  SheetModalContainer,
} from './styles'

interface IOptionData {
  description: string
  id: number
}

interface IFilterModel {
  options: IOptionData[]
  selected: IOptionData[]
  payloadOption: string
}

interface IProps {
  data: IFilterModel
  onChange: ({
    payloadOption,
    selectedOptions,
  }: {
    payloadOption: string
    selectedOptions: IOptionData[]
  }) => void
}

export function FilterMultiselect({ data, onChange }: IProps) {
  const [selectedItems, setSelectedItems] = useState<IOptionData[]>(
    data.selected ?? [],
  )

  function handlePress(selectedItem: IOptionData) {
    let newList = []
    if (hasObject(selectedItem)) {
      newList = selectedItems.filter(
        (oldItem) => oldItem.id !== selectedItem.id,
      )
    } else {
      newList = [...selectedItems, selectedItem]
    }
    onChange &&
      onChange({ payloadOption: data.payloadOption, selectedOptions: newList })
    setSelectedItems(newList)
  }

  function hasObject(obj: IOptionData) {
    return selectedItems.some((item) => item.id === obj.id)
  }
  return (
    <>
      <SheetModalContainer>
        <SheetModalHandle>Filters</SheetModalHandle>
      </SheetModalContainer>

      {data.options?.map((item, index) => (
        <React.Fragment key={item.id.toString()}>
          {index > 0 && <Separator />}
          <Container>
            <PressAbleContainer
              onClick={() => {
                handlePress(item)
              }}
            >
              <Checkbox isChecked={hasObject(item)} />
              <OptionLabel>{item.description}</OptionLabel>
            </PressAbleContainer>
          </Container>
        </React.Fragment>
      ))}
    </>
  )
}
